import { print } from 'graphql';
import {
  getAllOrdersQuery,
  getClosedOrdersQuery,
  getInActiveOrdersQuery,
} from './DashboardQueries';
import {
  getBnySatBaseUrl,
  getBnySatGraphBaseUrl,
  getConfigBaseUrl,
} from '../../services/apiService';
import { apiCall, createApiThunk, graphqlCall } from '../../utils/api';

export const getAllOrdersThunk = createApiThunk('GET_ALL_ORDERS', graphqlCall);
export const getInActiveOrdersThunk = createApiThunk('GET_INACTIVE_ORDERS', graphqlCall);
export const getClosedOrdersThunk = createApiThunk('GET_CLOSED_ORDERS', graphqlCall);
export const getAllDataVisualization = createApiThunk('GET_ALL_DATA_VISUALIZATION', apiCall);
export const onOrderCancelThunk = createApiThunk('ON_ORDER_CANCEL_THUNK', apiCall);
export const getAllHolidaysThunk = createApiThunk('GET_ALL_HOLIDAYS', apiCall);

export const getAllOrders = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getAllOrdersQuery());
  dispatch(getAllOrdersThunk({ url, query }));
};

export const getInActiveOrders = (fromDate: string, toDate: string) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getInActiveOrdersQuery(fromDate, toDate));
  return dispatch(getInActiveOrdersThunk({ url, query }));
};

export const getClosedOrders = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getClosedOrdersQuery());
  return dispatch(getClosedOrdersThunk({ url, query }));
};

export const getAllDataVisualizationDetails = (screenId) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/${screenId}`;
  return dispatch(getAllDataVisualization({ url, method: 'GET' }));
};

export const onOrderCancel =
  (orderId: any, version: number, basketRouting: any) => (dispatch: AppDispatch) => {
    const url = `${getBnySatBaseUrl()}/v1/bny/trades/${orderId}/${version}/cancel?basketRouting=${basketRouting}`;
    return dispatch(onOrderCancelThunk({ url, method: 'PUT', data: null }));
  };

export const getAllHolidays = () => (dispatch: AppDispatch) => {
  const url = `${getBnySatBaseUrl()}/v1/holidaycalendar/allbycurrency`;
  return dispatch(getAllHolidaysThunk({ url, method: 'GET' }));
};
